// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"468ae719","643":"468ae719"}[chunkId] + ".chunk.css";
};